module.exports = __webpack_public_path__ + "static/img/5420_phase_function_Paper_Points.e75ab9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5420_phase_function_Paper_Points.png
// module id = pbFH
// module chunks = 0